export default function StatsSection() {
  const stats = [
    {
      value: '۱۳+',
      label: 'سال تجربه',
      description: 'از سال ۱۳۹۳ در خدمت شما',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20office%20workspace%20with%20warm%20natural%20lighting%20a%20wooden%20desk%20with%20organized%20documents%20and%20a%20laptop%20soft%20beige%20and%20cream%20tones%20professional%20corporate%20atmosphere&width=600&height=800&seq=carland-stat-years-003&orientation=portrait',
    },
    {
      value: '۴۷,۰۰۰+',
      label: 'کاربر ثبت‌نامی',
      description: 'کارجویان موفق',
      image: 'https://readdy.ai/api/search-image?query=Modern%20professional%20handshake%20between%20two%20business%20people%20in%20a%20bright%20elegant%20office%20setting%20warm%20beige%20tones%20soft%20natural%20lighting%20clean%20minimalist%20background&width=600&height=800&seq=carland-stat-hires-004&orientation=portrait',
    },
    {
      value: '۵',
      label: 'مجوز رسمی',
      description: 'از مراجع معتبر',
      image: 'https://readdy.ai/api/search-image?query=Professional%20certificates%20and%20official%20documents%20elegantly%20arranged%20on%20a%20wooden%20desk%20with%20warm%20lighting%20sophisticated%20corporate%20atmosphere%20beige%20and%20cream%20color%20palette&width=600&height=800&seq=carland-stat-licenses-005&orientation=portrait',
    },
    {
      value: '۹۸٪',
      label: 'رضایت کارفرما',
      description: 'تضمین کیفیت',
      image: 'https://readdy.ai/api/search-image?query=Satisfied%20business%20professionals%20in%20a%20modern%20elegant%20office%20environment%20warm%20beige%20tones%20collaborative%20and%20positive%20atmosphere%20soft%20diffused%20lighting%20minimal%20design&width=600&height=800&seq=carland-stat-satisfaction-006&orientation=portrait',
    },
  ];

  return (
    <section id="stats" className="py-20 md:py-28 bg-white">
      <div className="px-6 md:px-12 lg:px-20">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6 reveal spring-right" style={{ opacity: 0 }}>
          <div className="text-right">
            <h2 className="text-3xl md:text-5xl font-black text-carland-dark leading-tight">
              آمار و دستاوردهای کارلند
            </h2>
          </div>
          <div className="text-right md:text-left">
            <p className="text-carland-muted text-sm md:text-base">
              شفافیت در ارائه خدمات و افتخارات ۱۳ ساله
            </p>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="group relative rounded-2xl overflow-hidden h-80 cursor-pointer reveal spring-scale"
              style={{ opacity: 0, animationDelay: `${0.12 * (index + 1)}s` }}
            >
              <img
                src={stat.image}
                alt={stat.label}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm rounded-xl px-4 py-2">
                <span className="text-carland-dark font-black text-xl">{stat.value}</span>
              </div>
              <div className="absolute bottom-0 right-0 left-0 p-5 text-white">
                <h4 className="text-lg font-bold mb-1">{stat.label}</h4>
                <p className="text-white/70 text-xs">{stat.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}